import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../../auth/redux/slice";
import { startSession, stopSession } from "./thunks";

export interface SessionState {
    documentId: number | null;
    accountId: number | null;
    loading: boolean;
    empty: boolean;
    error: string | null;
}

const initialState: SessionState = {
    documentId: null,
    accountId: null,
    loading: false,
    empty: false,
    error: null,
};

const sessionSlice = createSlice({
    name: "dataEntering",
    initialState,
    reducers: {
        dataEnteringEmpty() {
            return { ...initialState, empty: true };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(startSession.pending, () => ({
                ...initialState,
                loading: true,
            }))
            .addCase(startSession.fulfilled, (_state, action) => {
                if (!action.payload) return { ...initialState, empty: true };

                return {
                    ...initialState,
                    accountId: action.payload.accountId,
                    documentId: action.payload.documentId,
                    loading: false,
                };
            })
            .addCase(startSession.rejected, (_state, action) => ({
                ...initialState,
                error: action.error.message || "Start session failed",
            }))
            .addCase(stopSession.pending, (state) => ({
                ...state,
                loading: true,
            }))
            .addCase(stopSession.fulfilled, () => ({
                ...initialState,
            }))
            .addCase(stopSession.rejected, (state, action) => ({
                ...state,
                error: action.error.message || "Stop session failed",
            }))
            .addCase(logout.fulfilled, () => ({
                ...initialState,
            }));
    },
});

export const { dataEnteringEmpty } = sessionSlice.actions;
export const sessionReducer = sessionSlice.reducer;
